import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-logo-light',
  templateUrl: './gb-logo-light.component.html',
  styleUrls: ['./gb-logo-light.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbLogoLightComponent {}
